<!-- <div *ngIf="loading$ | async;" class="global-loader"><nz-spin nzTip="Loading..."></nz-spin></div> -->
<router-outlet></router-outlet>